export const COLUMN_WIDTHS = {
  name: '26%',
  jobTitle: '18%',
  employmentType: '18%',
  location: '15%',
  accountStatus: '18%',
  actions: '5%',
} as const;

export const ACTIONS_COLUMN_MIN_WIDTH = '3.5rem';
